import Vuex from 'vuex'
// import vueAuth from './auth.js'

import pubsub from 'pubsub-js'

let defaultIsAuth = false
if (window) {
  defaultIsAuth = window.localStorage.getItem('isAuth') === 'true'

  if (window.FN_isAuth !== undefined) {
    defaultIsAuth = window.FN_isAuth
  }
}

let checkAuth = false
pubsub.subscribe('socket.disconnect', () => {
  checkAuth = true
})
pubsub.subscribe('socket.connect', () => {
  if (checkAuth) {
    checkAuth = false

    import('src/R.js')
      .then(({ default : R }) => {
        R.loadUserData()
      })
  }
})

export default new Vuex.Store({

  state: {
    isAuth: defaultIsAuth
  },

  getters: {
    isAuth (state) {
      return state.isAuth
    }
  },

  // Mutation for when you use it as state property
  mutations: {
    isAuth (state, payload) {
      state.isAuth = !!payload.isAuth

      if (window) {
        window.localStorage.setItem('isAuth', state.isAuth)
      }

      if (!state.isAuth) {
        window.localStorage.removeItem('currentUser')
        // check page and move out
        import('src/app.js')
          .then(({ app }) => {
            let to = app.$route

            let requireAuth = false

            for (let match of to.matched) {
              if (match.meta.requireAuth !== undefined) requireAuth = match.meta.requireAuth
            }

            if (requireAuth && !state.isAuth) {
              app.$router.push({ path: '/forceLanding' })
            }
          })
      }
    }
  },

  actions: {

    // Perform VueAuthenticate login using Vuex actions
    // login (context, payload) {
    //   vueAuth.login(payload.user, payload.requestOptions).then((response) => {
    //     context.commit('isAuth', {
    //       isAuth: vueAuth.isAuthenticated()
    //     })
    //   })
    // }
  }
})
